import React from "react";
import CustomDialog from "../../components/common/CustomDialog";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import Grid from "../../components/layout/grid/Grid";
import { advisorRejectFn } from "../../Services/advisorService";
import { errorToast ,successToast} from "../../utils/toasts";

const ResubmissionModal = ({ open, setOpen,id, setIsActionDisabled,setIsRejectionEnabled, onConfirm }) => {
  console.log("id",id);
  
  return (
    <CustomDialog open={open} setOpen={setOpen} title="Ask For Re-submission">
      <div className="mb-4">
        <p className="text-gray-500 text-sm">
          Select the Reason And Enter What is Wrong in the form
        </p>
      </div>
      <hr />

      <Grid container className="flex justify-between items-center ">
        <Grid item xs={6} className=" flex ">
          <CustomButton
            type="button"
            variant="default"
            label="Cancel"
            className="w-full m-0"
            onClick={() => setOpen(false)}
          />
        </Grid>

        <Grid item xs={6} className="flex justify-end">
          <CustomButton
            type="button"
            label="confirm"
            className="m-2"
            onClick={() =>{
              
                setIsActionDisabled(true);
                setIsRejectionEnabled(true);
              setOpen(false);
            }}
          />
        </Grid>
      </Grid>
    </CustomDialog>
  );
};

export default ResubmissionModal;
